import { Plugin } from 'vue';
import { install } from './plugin';

export default {
  install,
} as Plugin;
